"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../api");
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RemoveCouponFromPackageButton',
  props: {
    packageId: {
      type: [String, Number],
      required: true
    },
    coupon: {
      type: Object,
      required: true
    }
  },
  created: function created() {
    console.log('RemoveCouponButton created with props:', {
      packageId: this.packageId,
      coupon: this.coupon
    });

    // Validate props
    if (!this.coupon || typeof this.coupon.id === 'undefined') {
      console.error('Invalid coupon object provided to RemoveCouponFromPackageButton:', this.coupon);
    }
  },
  methods: {
    confirmRemove: function confirmRemove() {
      var _this = this;
      this.$confirm('确定从券包中移除此优惠券吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.removeUsingApi();
      }).catch(function () {
        // 用户取消操作
      });
    },
    removeUsingApi: function removeUsingApi() {
      var _this2 = this;
      if (!this.coupon || typeof this.coupon.id === 'undefined') {
        console.error('Invalid coupon object:', this.coupon);
        this.$message.error('无效的优惠券数据');
        return;
      }
      var couponId = Number(this.coupon.id);
      var packageId = Number(this.packageId);
      console.log('Removing coupon with API - Coupon ID:', couponId, 'Package ID:', packageId);
      this.$set(this, 'loading', true);
      (0, _api.removeCouponFromPackageApi)(packageId, couponId).then(function (res) {
        console.log('Remove success:', res);
        _this2.$message.success('优惠券已从券包中移除');
        _this2.$emit('success');
        _this2.$set(_this2, 'loading', false);
      }).catch(function (error) {
        console.error('Remove failed:', error);
        _this2.$message.error('移除失败: ' + (error && error.message ? error.message : '请重试'));
        _this2.$set(_this2, 'loading', false);
      });
    }
  }
};